/**
 * route.ts — where the public clinical-safety page lives, as constants.
 *
 * Owner repo: @thegpservice/gpsclinics-portal. Slice: public clinical-safety
 * page (2026-08-20).
 *
 * WHY THE PATHS ARE CONSTANTS AND NOT STRING LITERALS AT EACH CALL SITE. Four
 * places have to agree on them — the route table, the payment screen's "Read
 * more" link, the analytics path gate, and the specs — and one of the two is a
 * MISSPELLING we are deliberately keeping alive. A typo re-typed by hand in one
 * of four places produces a safety link that 404s, which is the single worst
 * dead link this portal can serve. Typing it once makes that impossible.
 *
 * THE MISSPELLING IS LOAD-BEARING. `…-safty` is the URL as the CTO first wrote
 * it, and it may already have been shared before the spelling was corrected.
 * Deleting it would break links we cannot recall. It resolves to the correct
 * URL rather than rendering the page itself, so there is exactly one address
 * that serves this content and one that points at it.
 */

/** The canonical public clinical-safety page. */
export const CLINICAL_SAFETY_PATH = '/weightloss-clinical-safety';

/** The CTO's original spelling — permanently redirected to the canonical path. */
export const CLINICAL_SAFETY_LEGACY_PATH = '/weightloss-clinical-safty';

/**
 * The clinic whose medicines this page publishes.
 *
 * Read from a constant, NOT parsed out of the pathname. The pathname is a fixed
 * marketing-shaped URL rather than a `/:clinicSlug` route, and deriving a slug
 * by stripping a suffix off it would quietly change which clinic's medicines are
 * published the day someone renames the page. When a second clinic needs a
 * safety page it gets its own path constant and its own slug, side by side with
 * these — not a clever rule that infers one from the other.
 */
export const CLINICAL_SAFETY_CLINIC_SLUG = 'weightloss';
